import {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {SOTable} from './SOTable'
import {useTranslation} from 'react-i18next'
import {withProtectedRoute} from '../../../utils/withProtectedRoute'

export const SOWrapper: FC = withProtectedRoute(() => {
  const {t} = useTranslation()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('MANAGEMENT_SO.TITLE')}</PageTitle>
      <SOTable className='card-xxl-stretch mb-5 mb-xl-8' />
    </>
  )
})
